'use client';

/**
 * SLIMS PRO — contenuti specifici del chrome. Header, sidebar e frame della shell
 * sono condivisi con SLIMS CER (`AppHeader`, `SidebarNavigation`, `AppShellFrame`):
 * qui restano solo i controlli che PRO inserisce nei loro slot.
 */

export type ProModeId = 'fleet' | 'single' | 'field';

export interface ProMode {
	id: ProModeId;
	label: string;
}

export const PRO_MODES: ProMode[] = [
	{ id: 'fleet', label: 'Fleet Multi-Sito' },
	{ id: 'single', label: 'Impianto Singolo' },
	{ id: 'field', label: 'Campo Utility-Scale' },
];

export interface ProPlantOption {
	id: string;
	label: string;
}

export interface ProPlantSelectProps {
	/** Impianti/campi selezionabili per la modalità corrente; vuoto → selettore nascosto. */
	plants: ProPlantOption[];
	selectedPlantId: string | null;
	onSelectPlant: (id: string) => void;
}

/** Selettore impianto dell'header PRO, dimensionato sui controlli dell'header. */
export function ProPlantSelect({ plants, selectedPlantId, onSelectPlant }: ProPlantSelectProps) {
	if (plants.length === 0) return null;
	return (
		<select
			aria-label="Impianto"
			value={selectedPlantId ?? ''}
			onChange={(e) => onSelectPlant(e.target.value)}
			className="h-[38px] max-w-52 flex-none truncate rounded-btn border border-border bg-card px-2.5 text-[13px] text-brand outline-none focus:border-brand"
		>
			{plants.map((p) => (
				<option key={p.id} value={p.id}>
					{p.label}
				</option>
			))}
		</select>
	);
}

export interface ProScopeOption {
	value: string;
	label: string;
}

export interface ProScopeGroup {
	/** Without a label the options sit outside any group. */
	label?: string;
	options: ProScopeOption[];
}

export interface ProScopeSelectProps {
	groups: ProScopeGroup[];
	value: string;
	onChange: (value: string) => void;
}

/** The Fleet scope of the header (mock v5.0 `#flsel`): aggregates, then plants, then fields. */
export function ProScopeSelect({ groups, value, onChange }: ProScopeSelectProps) {
	const option = (o: ProScopeOption) => (
		<option key={o.value} value={o.value}>
			{o.label}
		</option>
	);
	return (
		<select
			aria-label="Ambito"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			className="h-[38px] max-w-64 flex-none truncate rounded-btn border border-border bg-card px-2.5 text-[13px] text-brand outline-none focus:border-brand"
		>
			{groups.map((g) =>
				g.label ? (
					<optgroup key={g.label} label={g.label}>
						{g.options.map(option)}
					</optgroup>
				) : (
					g.options.map(option)
				),
			)}
		</select>
	);
}
